import { CONTENT_ALIAS } from './const.config';

// Define page-title configurations
const PAGE_TITLE_LIST = {
  OVERVIEW_DASHBOARD: 'Overview Dashboard',
  ADMIN_USERS: 'Users',
  SUBSCRIBERS: 'Subscribers',
  CONTACTS: 'Contact',
  CONTENT_CHANNELS: 'Content / Channels',
  CONTENT_CATEGORY: `Content / ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  CONTENT_SHOW: `Content / ${CONTENT_ALIAS.SHOW_PLURAL}`,
  CONTENT_VIDEOS: `Content / ${CONTENT_ALIAS.VIDEO_PLURAL}`,
  CONTENT_SEQUENCE: 'Content / Sequence',
  CONTENT_SETTINGS: 'Content / Settings',
  CONTENT_WEB: 'Content / Web',
  REPORTS_OVERVIEW_VIDEOS: `Analytics Reports / Overview (${CONTENT_ALIAS.VIDEO_PLURAL})`,
  REPORTS_LIVE_USERS: 'Analytics Reports / Live Users',
  REPORTS_WATCH_SESSIONS: 'Analytics Reports / Watch Sessions',
  REPORTS_VIDEO_WATCH_SESSIONS: `Analytics Reports / ${CONTENT_ALIAS.VIDEO_PLURAL} Watch Sessions`,
  REPORTS_APP_SESSIONS: 'Analytics Reports / App Sessions',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  ERROR_NOT_FOUND: '404 Not Found',
};

export default PAGE_TITLE_LIST;
